import { createConfig } from "@Utils/createConfig";
import { gatewayUrl } from "@Constants/gatewayUrl";
import axios from "axios";
export async function getSavedPrompts(token) {
    const header = createConfig(token);
    const url = `${gatewayUrl}/chats/promptBank`;
    try {
        const response = await axios.get(url, header);
        return response.data;
    } catch (error) {
        console.error("Error fetching saved prompts:", error);
        throw new Error("Failed to fetch saved prompts");
    }
}
